import { PdSelect } from "./pd-select/PdSelect.js";
//#region src/pd-select/pd-select.ts
var tag = "pd-select";
if (!customElements.get(tag)) customElements.define(tag, PdSelect);
//#endregion
export { PdSelect };
